import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useEffect, useState } from 'react';
import { Bubble, Card } from 'tea-component';
import { useLocal } from '../../utils/customHook';

import './index.scss';
export default function CardSlot(props: any) {
  // children:  插入内容
  // title: 标题这里字符串和dom元素都可以
  // iconList: 右边的icon 不传的话只显示下载
  // isAction: 如果需要左边右边箭头可以点击去的 true ，默认flase， 可以不传
  // getChange：右边按钮点击事件
  // iconShow: 是否展示右侧icon  默认flase，  true的话不展示
  // isEyes: 是否展示右侧的眼睛查看icon  默认flase，  true的话不展示
  // hiddenDownload: 是否隐藏右侧的下载图标  默认flase，  true的话隐藏下载图标
  const {
    children,
    title,
    onDownload,
    activeTab,
    isEyes,
    iconList,
    isAction,
    iconShow,
    getChange,
    secondTitle,
    hiddenDownload,
    className
  } = props;
  const [action, setAction] = useState(activeTab);
  const [isShow, setShow] = useState(false);
  const { getLocalText } = useLocal();

  useEffect(() => {
    setAction(activeTab);
  }, [activeTab]);

  return (
    <>
      <Card className={`card-sort ${className}`}>
        <Card.Body
          title={
            <>
              {
                isAction ? (
                  <div className="card-sort-title">
                    {title}
                    <SvgIcon type="arrow-right" className="card-sort-icon" />
                  </div>
                ) : (
                  title
                )
              }
              {secondTitle}
            </>
          }
          operation={
            !iconShow ? (
              <div className="card-sort-flex">
                {!isEyes ? (
                  <Bubble
                    dark
                    content={getLocalText(
                      !isShow ? 'common_show_values' : 'common_hide_values',
                    )}
                  >
                    <i
                      onClick={() => {
                        setShow(!isShow);
                        getChange('eye');
                      }}
                      className="card-sort-item"
                    >
                      <SvgIcon
                        className="card-sort-charicon"
                        type={isShow ? 'eyes-closed' : 'open-eyes'}
                      />
                    </i>
                  </Bubble>
                ) : null}
                {iconList?.map((e: any, i: any) => {
                  return (
                    <Bubble content={e.context} dark key={i}>
                      <i
                        className={
                          e.icon == action
                            ? 'card-sort-action'
                            : 'card-sort-item'
                        }
                        onClick={() => {
                          setAction(e.icon);
                          getChange(e.icon, i);
                        }}
                      >
                        <SvgIcon type={e.icon} className="card-sort-charicon" />
                      </i>
                    </Bubble>
                  );
                })}
                {
                  !hiddenDownload ? (<Bubble dark>
                    <i className="card-sort-char" onClick={onDownload}>
                      <SvgIcon type="download" className="card-sort-charicon" />
                    </i>
                  </Bubble>) : null
                }

              </div>
            ) : (
              ''
            )
          }
        >
          {children ? children : <div className="line-text">图表占位</div>}
        </Card.Body>
      </Card>
    </>
  );
}
